import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ComingInfo from './ComingInfo';
import EmptyResult from 'components/others/EmptyResult';

interface Props {
    comings: Record<string, any>[] | null;
    fetching: boolean;
    error: boolean;
    fetchPayments: () => void;
}

const TabComingList = ({ comings, error }: Props) => {
    const { t } = useTranslation(['Warehouses', 'common']);

    if (error) return <div className="text-danger mt-3">{t('common:messError')}</div>;

    const safeComings = Array.isArray(comings) ? comings.filter((c) => c.wpartnerId === 0) : [];

    if (safeComings.length === 0) {
        return (
            <div className="my-3">
                <EmptyResult />
            </div>
        );
    }

    return (
        <div className="crm-table-wrap my-3">
            <Table className="OffComingListTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        <td className="head-date">{t('fields.date')}</td>
                        <td className="head-user">{t('fields.userName')}</td>
                        <td className="head-count">{t('fields.count')}</td>
                        <td className="head-price">{t('labelPrice')}</td>
                        <td className="head-amount">{t('labelAmount')}</td>
                        <td className="head-description" title={t('labelDescription')}>
                            <i className="bi bi-chat-left-text"></i>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    {safeComings.map((coming, index) => (
                        <ComingInfo key={coming?.ID ?? index} coming={coming} />
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default TabComingList;
